import menumMobile from "../../src/scripts/menu-mobile.js";
import initScrollSmooth from "../../src/scripts/scroll-smooth.js";

menumMobile();
initScrollSmooth();
